<template>
  <div class="d-flex flex-column h-100">
    <SortableHeaderLabel :params="params" />

    <div class="mt-auto">
      <v-tooltip
        right
        max-width="18rem"
        dense
        v-bind="defaultVTooltipProps"
        :open-on-focus="false"
        :open-on-click="false"
      >
        <template #activator="{ on }">
          <v-text-field
            v-on="on"
            v-model="value"
            dense
          >
            <template #label>
              <v-icon
                small
                left
              >
                mdi-magnify
              </v-icon>
              <span class="text-muted font-weight-light small-caption">Search</span>
            </template>

            <template #append>
              <v-icon
                v-if="value"
                small
                class="mr-2 cursor-pointer"
                @click="value = ''"
              >
                mdi-close-circle
              </v-icon>
            </template>
          </v-text-field>
        </template>
        <div>
          <span>Search by:</span>
          <ul>
            <li>name</li>
            <li>identifiers (SID, ChemID, CASRN, CID)</li>
            <li>structural keys (SMILES, InChI, InChIKey)</li>
          </ul>
        </div>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { defaultVTooltipProps } from '@/utils/defaultProps'
import SortableHeaderLabel from './SortableHeaderLabel.vue'

export default {
  components: {
    SortableHeaderLabel,
  },

  data() {
    return { value: '', api: null, defaultVTooltipProps }
  },

  computed: {
    colId() {
      return this.params?.column?.getColId?.()
    },
  },

  watch: {
    value: {
      handler: async function (newVal) {
        return this.api
          .setColumnFilterModel(this.colId, {
            filter: newVal,
            type: 'contain',
            filterType: 'text',
          })
          .then(() => {
            this.api.onFilterChanged()
          })
          .catch((error) => {
            console.error('Error setting filter model for colId:', this.colId, 'Error:', error)
          })
      },
    },
  },

  mounted() {
    this.api = this.params.api
  },
}
</script>

<style scoped>
.small-caption {
  font-size: 0.85rem;
  line-height: 1;
}
</style>
